import React, { useState, useEffect } from "react";
import { ButtonGroup, ToggleButton } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { setCulture } from "culture/useCultureChange";
import nlFlag from "assets/icon/nl.png";
import ukFlag from "assets/icon/uk.png";
import indiaFlag from "assets/icon/india.svg";
import { useAppContext } from "../../../providers/appProvider";
import { getDomainConfig } from "../../../config/domainConfig";

const FLAG_MAP = {
  nl: nlFlag,
  en: ukFlag,
  hi: indiaFlag,
};

const LanguageButtons = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { config, setConfig } = useAppContext();
  const { supportedLanguages, defaultLanguage, showLanguageSwitcher } = getDomainConfig();
  const [lang, setLang] = useState(defaultLanguage.toLowerCase());

  const supported = supportedLanguages.map((code) => code.toLowerCase());
  const isSupported = (value) => !!value && supported.includes(value.toLowerCase());

  //  1. INITIAL SYNC (fixes login case)
  useEffect(() => {
    if (!showLanguageSwitcher) {
      const fallback = defaultLanguage.toLowerCase();
      setLang(fallback);
      setConfig("language", fallback);
      setCulture(fallback, navigate, location);
    } else {
      const storedCulture = localStorage.getItem("culture");
      const initialLang = isSupported(storedCulture)
        ? storedCulture.toLowerCase()
        : isSupported(config.language)
        ? config.language.toLowerCase()
        : defaultLanguage.toLowerCase();
      setLang(initialLang);
    }
  }, []);

  //  2. SYNC when Profile saves language
  useEffect(() => {
    if (config.language && isSupported(config.language) && config.language.toLowerCase() !== lang) {
      setLang(config.language.toLowerCase());
    }
  }, [config.language]);

  const handleLangChange = (value) => {
    setLang(value);
    setConfig("language", value);
    setCulture(value, navigate, location);
  };

  const languages = supportedLanguages.map((code) => {
    const value = code.toLowerCase();
    return { name: code, value, flag: FLAG_MAP[value] };
  });

  if (!showLanguageSwitcher) return null;

  return (
    <ButtonGroup>
      {languages.map((language) => (
        <ToggleButton
          key={language.value}
          id={`lang-${language.value}`}
          type="radio"
          variant="outline-primary"
          name="language"
          value={language.value}
          checked={lang === language.value}
          onChange={(e) => handleLangChange(e.currentTarget.value)}
          className="d-flex align-items-center py-0 px-1 data-font-size"
        >
          <img
            src={language.flag}
            alt={language.name}
            className="me-1"
            width="12"
            height="8"
          />
          {language.name}
        </ToggleButton>
      ))}
    </ButtonGroup>
  );
};

export default LanguageButtons;
